import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { reduxForm, change } from 'redux-form';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Form from 'react-bootstrap/lib/Form';

import CommonFields from '../CommonFields/CommonFields';

import submit from './submit';
import validate from './validate';
import messages from '../../locale/jsonMessages';

import cs from '../../components/commonStyle.css';

class EditProfileForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      countryCode: 'US',
      country: '+1'
    }
  }

  componentDidMount() {
    const { change, initialValues } = this.props;
    let loggedinEmail;
    if (initialValues && initialValues.email) {
      loggedinEmail = initialValues.email;
    }
    change('loggedinEmail', loggedinEmail);
  }

  UNSAFE_componentWillReceiveProps() {
    const { change, initialValues } = this.props;
    let loggedinEmail;
    if (initialValues && initialValues.email) {
      loggedinEmail = initialValues.email;
    }
    change('loggedinEmail', loggedinEmail);
  }


  componentWillMount() {
    const { change, initialValues } = this.props;
    const { countryCode, country } = this.state;
    change('countryCode', countryCode);
    change('dialCode', initialValues?.countryCode ? initialValues?.countryCode : country);
  }

  render() {
    const { handleSubmit, initialValues } = this.props;
    const { formatMessage } = this.props.intl;
    return (
      <div className={cx(cs.commonBorderSection, 'whiteBgColor')}>
        <h2 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom4)}>{formatMessage(messages.editYourProfile)}</h2>
        <Form onSubmit={handleSubmit(submit)}>
          <CommonFields initialValues={initialValues} />
        </Form>
      </div>
    )
  }
}
EditProfileForm = reduxForm({
  form: 'EditProfileForm',
  validate,
})(EditProfileForm);

const mapState = (state) => ({
  initialValues: state.account.data
});
const mapDispatch = {
  change
};

export default compose(injectIntl, withStyles(cs), connect(mapState, mapDispatch))(EditProfileForm);